import React, { useEffect, useState } from 'react';
import { ArrowRight, Building2, Briefcase } from 'lucide-react';
interface Props {
  onContinue: () => void;
}
const ROLES = ['CEO / Founder', 'C-Level Executive', 'Director / Manager', 'Investor', 'Policy Maker', 'Researcher / Academic', 'Student', 'Other'];
export function OnboardingRole({
  onContinue
}: Props) {
  const [role, setRole] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [organization, setOrganization] = useState('');
  const [mounted, setMounted] = useState(false);
  const isValid = role !== '' && organization.trim() !== '';
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 50);
    return () => clearTimeout(timer);
  }, []);
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] relative" data-id="element-369">
      <div className="flex-1 overflow-y-auto px-6 pt-12 pb-32" data-id="element-370">
        {/* Step Indicator */}
        <div className="flex justify-center gap-2 mb-8 transition-all duration-700 ease-out" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(16px)',
        transitionDelay: '0ms'
      }} data-id="element-371">
          <div className="w-6 h-1.5 rounded-full bg-[#C5D82D]" data-id="element-372" />
          <div className="w-1.5 h-1.5 rounded-full bg-[#2A2A2A]" data-id="element-373" />
          <div className="w-1.5 h-1.5 rounded-full bg-[#2A2A2A]" data-id="element-374" />
        </div>

        <div className="mb-10 text-center transition-all duration-700 ease-out" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(20px)',
        transitionDelay: '120ms'
      }} data-id="element-375">
          <h1 className="text-[24px] font-medium text-white mb-3 tracking-tight" data-id="element-376">
            Parlaci di te
          </h1>
          <p className="text-[15px] text-[#888888] leading-relaxed max-w-[280px] mx-auto" data-id="element-377">
            Queste informazioni ci aiuteranno a presentarti alle persone giuste
            durante il Summit.
          </p>
        </div>

        <div className="space-y-6" data-id="element-378">
          {/* Role Field */}
          <div className="space-y-2 relative z-30 transition-all duration-700 ease-out" style={{
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(24px)',
          transitionDelay: '250ms'
        }} data-id="element-379">
            <label className="text-[13px] font-medium text-[#888888] uppercase tracking-wider flex items-center gap-2" data-id="element-380">
              <Briefcase className="w-4 h-4" data-id="element-381" />
              Il tuo ruolo
            </label>
            <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="w-full bg-[#141414] border border-[#2A2A2A] rounded-xl p-4 text-left flex items-center justify-between text-white focus:border-[#C5D82D] transition-colors" data-id="element-382">
              <span className={role ? 'text-white' : 'text-[#999999]'} data-id="element-383">
                {role || 'Seleziona il tuo ruolo'}
              </span>
              <div className={`transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} data-id="element-384">
                ▼
              </div>
            </button>

            {/* Dropdown */}
            {isDropdownOpen && <div className="absolute top-full left-0 right-0 mt-2 bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl overflow-hidden z-50 shadow-xl" data-id="element-385">
                {ROLES.map(r => <button key={r} onClick={() => {
              setRole(r);
              setIsDropdownOpen(false);
            }} className="w-full text-left px-4 py-3 text-[14px] text-white hover:bg-[#2A2A2A] transition-colors border-b border-[#2A2A2A]/50 last:border-0" data-id="element-386">
                    {r}
                  </button>)}
              </div>}
          </div>

          {/* Organization Field */}
          <div className="space-y-2 transition-all duration-700 ease-out" style={{
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(24px)',
          transitionDelay: '380ms'
        }} data-id="element-387">
            <label className="text-[13px] font-medium text-[#888888] uppercase tracking-wider flex items-center gap-2" data-id="element-388">
              <Building2 className="w-4 h-4" data-id="element-389" />
              Organizzazione
            </label>
            <input type="text" value={organization} onChange={e => setOrganization(e.target.value)} placeholder="Es. EIIS, Barilla, Google..." className="w-full bg-[#141414] border border-[#2A2A2A] rounded-xl p-4 text-white placeholder:text-[#999999] focus:outline-none focus:border-[#C5D82D] transition-colors" data-id="element-390" />
          </div>
        </div>
      </div>

      {/* Fixed Bottom Bar */}
      <div className="absolute bottom-0 left-0 right-0 bg-[#0D0D0D]/90 backdrop-blur-xl border-t border-[#2A2A2A] p-6 pb-8 transition-all duration-700 ease-out" style={{
      opacity: mounted ? 1 : 0,
      transform: mounted ? 'translateY(0)' : 'translateY(16px)',
      transitionDelay: '500ms'
    }} data-id="element-391">
        <div className="flex flex-col gap-3" data-id="element-392">
          <button onClick={onContinue} disabled={!isValid} className={`
              w-full rounded-full py-3.5 font-medium text-base transition-all duration-200 flex items-center justify-center gap-2
              ${isValid ? 'bg-transparent border border-[#C5D82D] text-white active:scale-[0.98]' : 'bg-transparent border border-[#2A2A2A] text-[#888888] cursor-not-allowed'}
            `} data-id="element-393">
            Continua
            <ArrowRight className="w-4 h-4" data-id="element-394" />
          </button>
          <button onClick={onContinue} className="w-full py-2 text-[13px] font-medium text-[#999999] hover:text-[#CCCCCC] transition-colors" data-id="element-395">
            Salta per ora
          </button>
        </div>
      </div>
    </div>;
}